import { render, staticRenderFns } from "./JobsPostulations.vue?vue&type=template&id=3a8239a7&scoped=true"
import script from "./JobsPostulations.vue?vue&type=script&lang=ts"
export * from "./JobsPostulations.vue?vue&type=script&lang=ts"
import style0 from "./JobsPostulations.vue?vue&type=style&index=0&id=3a8239a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8239a7",
  null
  
)

export default component.exports